<template>
  <div>
    <div v-if="showMessage">
      <Message :content="showMessageContent" />
    </div>
    <Audio />
    <div class="main-container">
      <Header :msg="headerMessage" />
      <Button @sort="sort" />
      <CardGroup :content="sortedCards" @select="selector" />
    </div>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Audio from "./components/Audio.vue";
import Message from "./components/Message.vue";
import Button from "./components/Button.vue";
import CardGroup from "./components/CardGroup.vue";
import "animate.css";

export default {
  name: "App",
  data() {
    return {
      headerMessage: "Matching Cards",
      compare: [],
      showMessage: false,
      showMessageContent: false,
      sortedCardsId: "",
      sortedCards: [],
      oGcards: [
        {
          image: "1.png",
          alt: "Blood Drop Bat",
          id: 1,
          compare: "1",
          show: false,
        },
        {
          image: "2.png",
          alt: "Skeleton Sperm",
          id: 2,
          compare: "2",
          show: false,
        },
        {
          image: "3.png",
          alt: "Saliva",
          id: 3,
          compare: "3",
          show: false,
        },
        {
          image: "4.png",
          alt: "Blood",
          id: 4,
          compare: "4",
          show: false,
        },
        {
          image: "5.png",
          alt: "Semen Drop",
          id: 5,
          compare: "5",
          show: false,
        },
        {
          image: "6.png",
          alt: "Urine Drop",
          id: 6,
          compare: "6",
          show: false,
        },
        {
          image: "7.png",
          alt: "Blood Drop Bat",
          id: 7,
          compare: "7",
          show: false,
        },
        {
          image: "8.png",
          alt: "Skeleton Sperm",
          id: 8,
          compare: "8",
          show: false,
        },
        {
          image: "1.png",
          alt: "Blood Drop Bat",
          id: 9,
          compare: "1",
          show: false,
        },
        {
          image: "2.png",
          alt: "Skeleton Sperm",
          id: 10,
          compare: "2",
          show: false,
        },
        {
          image: "3.png",
          alt: "Saliva",
          id: 11,
          compare: "3",
          show: false,
        },
        {
          image: "4.png",
          alt: "Blood",
          id: 12,
          compare: "4",
          show: false,
        },
        {
          image: "5.png",
          alt: "Semen Drop",
          id: 13,
          compare: "5",
          show: false,
        },
        {
          image: "6.png",
          alt: "Urine Drop",
          id: 14,
          compare: "6",
          show: false,
        },
        {
          image: "7.png",
          alt: "Blood Drop Bat",
          id: 15,
          compare: "7",
          show: false,
        },
        {
          image: "8.png",
          alt: "Skeleton Sperm",
          id: 16,
          compare: "8",
          show: false,
        },
      ],
    };
  },
  methods: {
    selector: function(compare, id) {
      if (this.compare.length < 2) {
        for (let i = 0; i < this.sortedCards.length; i++) {
          if (id == this.sortedCards[i].id) {
            this.sortedCards[i].show = !this.sortedCards[i].show;
          }
        }
        let item = {
          id: id,
          compare: compare,
        };
        this.compare.push(item);
      }
      setTimeout(() => this.clearCompareArr(), 2000);
    },
    clearCompareArr: function () {
      let cards = this.sortedCards;
      let compareCards = this.compare;
      if (compareCards.length == 2) {
        if (compareCards[0].compare == compareCards[1].compare) {
          for (let i = 0; i < compareCards.length; i++) {
            for (let j = 0; j < cards.length; j++) {
              if (compareCards[i].id == cards[j].id) {
                this.sortedCards.splice(j, 1);
              }
            }
          }
          this.clearMessage();
          this.showMessageContent = true;
          setTimeout(() => this.clearMessage(), 2500);
        } else {
          for (let i = 0; i < cards.length; i++) {
            for (let j = 0; j < compareCards.length; j++) {
              if (compareCards[j].id == cards[i].id) {
                cards[i].show = !cards[i].show;
              }
            }
          }
          this.clearMessage();
          this.showMessageContent = false;
          setTimeout(() => this.clearMessage(), 2500);
        }

        this.compare = [];
      }
    },
    clearMessage: function () {
      this.showMessage = !this.showMessage;
    },
    clearSortedArr: function () {
      this.sortedCards = [];
      for (let i = 0; i < this.oGcards.length; i++) {
        this.oGcards[i].show = false;
      }
    },
    sort: function () {
      this.clearSortedArr();
      console.log("fired");
      let array = [...this.oGcards];
      let m = array.length,
        t,
        i;
      // While there remain elements to shuffle…
      while (m) {
        // Pick a remaining element…
        i = Math.floor(Math.random() * m--);

        // And swap it with the current element.
        t = array[m];
        array[m] = array[i];
        array[i] = t;
      }

      this.sortedCardsId = Math.floor(Math.random() * 1000);
      this.sortedCards = [...array];
    },
  },
  computed: {},
  mounted() {},
  components: {
    Header,
    Audio,
    Message,
    Button,
    CardGroup
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Trispace:wght@600&display=swap");

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  font-family: "Trispace", sans-serif;
  font-size: 1.6rem;
  line-height: 2.5rem;
}

html {
  font-size: 62.5%;
}

body {
  position: relative;
  padding: 0rem;
  box-sizing: border-box;
}

button {
  cursor: pointer;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 2.5rem;
  line-height: 4rem;
  margin-bottom: 1rem;
}

.h1 {
  font-size: 3rem;
}

#app {
  background: lightblue;
}

.main-container {
  transition: all 0.5s ease;
  min-height: 100vh;
  width: 90%;
  padding: 1rem;
  margin: 0 auto;
}

.container {
  transition: all 0.5s ease;
  min-height: 10rem;
  width: 90%;
  padding: 1rem;
  margin: 0 auto;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.hidden {
  display: none;
}

@media (min-width: 545px) {
  .container {
    width: 80%;
    margin: 0 auto;
    flex-flow: row wrap;
    justify-content: center;
  }
}
</style>
